module.exports = __webpack_public_path__ + "static/media/be.3b11d86b.png";